import './Text.css';



export function AnimationAndInteraction() {
  return (
    <div class="body">

<div class="row" id="GalleryThree">

                  <div class="column">

                  <a href="/ ">
               <img alt="Ballroom Bookmarks" src="BallroomBookmarks01.png"></img>
            </a>

            <h4><a href="/ ">Ballroom Bookmarks</a>
                , 2026
                <br/> 
                Minneapolis Institute of Art</h4>
</div>

</div>
        <div class="row" id="GalleryThree">

 <div class="column">

               <a href="/Preach"> <img alt="Preach" src="Preach1.jpg"/></a>

            <br/><h4>
                <a href="/Preach">
                Preach
                </a>, 2025
                <br/>An interactive exploration on community building practices.
               <br/>
               Poetry Worksheets, Poster, Open Mic, and Video Essay.
                </h4>
        </div>

 <div class="column">


                  <a href="/ ">
               <img alt="Kid's Table" src="KT.gif"></img>
            </a>

            <h4><a href="/ ">Kid's Table</a>
                , 2025
                       <br/> Bauhaus Universität Wiemar
                                <br/>What was something you couldn't say as a kid that you can say now? 
                                <br/> A poetic public game as a marketing tactic.
          </h4>

</div>
 <div class="column">

                  <a href="/ ">
               <img alt="" src="BTComCollage01.jpg"></img>
            </a>

            <h4><a href="/ ">Bob-Thompson Inspired Community Collage</a>
                , 2025
                <br/> 
                Minneapolis Institute of Art</h4>

  </div>
        
        </div></div>
        



  );
}
